import React, { FC } from 'react';
import { Container, Grid, Theme, Typography } from '@material-ui/core';
import { ImageSection } from 'components/energy5/structures';
import { makeStyles } from '@material-ui/styles';
import { placeOrderImage } from 'assets/images/led-landing';
import useI18n from "evcharging/hooks/useI18n";

const useStyles = makeStyles((theme: Theme) => {
  return {
    underTitle: {
      [theme.breakpoints.up('sm')]: {
        fontSize: 36,
      },
    },
  };
});

const SelectReplacementsSection: FC = () => {
  const { t } = useI18n();

  const classes = useStyles();

  return (
    <>
      <Container maxWidth={false} fixed>
        <Grid container justifyContent="center">
          <Grid item lg={8} md={10} xs={12}>
            <Typography
              variant="h2"
              className={classes.underTitle}
              align="center"
              color="secondary"
            >
              {t('landing.place-order')}
            </Typography>
          </Grid>
        </Grid>
      </Container>
      <ImageSection
        title={t('landing.place-order.title')}
        text={t('landing.place-order.description')}
        imageSrc={placeOrderImage}
        width={1200}
        height={676}
        showBlueBgEffect
        imageBigLg
        setImageBorder
      />
    </>
  );
};

export default SelectReplacementsSection;
